import { jsx, jsxs } from "react/jsx-runtime";
import cx from "classnames";
import Button from "@ingka/button";
import cross from "@ingka/ssr-icon/paths/cross";
import arrowBack from "@ingka/ssr-icon/paths/arrow-left";
const ModalHeader = (props) => {
  const {
    title = "",
    titleId = "",
    prefix = "",
    className = "",
    closeBtnClick,
    ariaCloseTxt = "Close",
    backBtnClick,
    ariaBackBtnTxt = "Back",
    floating = false,
    children,
    ...other
  } = props;
  const wrapperClasses = cx(
    `${prefix}modal-header__title-wrapper`,
    !backBtnClick && `${prefix}modal-header__title-wrapper--padded`
  );
  const headerClasses = cx(
    `${prefix}modal-header`,
    floating && `${prefix}modal-header--floating-header`,
    className
  );
  return /* @__PURE__ */ jsxs("div", { className: headerClasses, ...other, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: cross,
        onClick: closeBtnClick,
        className: `${prefix}modal-header__close`,
        "aria-label": ariaCloseTxt
      }
    ),
    !floating && (title || children) && /* @__PURE__ */ jsxs("div", { className: wrapperClasses, children: [
      title && /* @__PURE__ */ jsx("h2", { id: titleId, className: `${prefix}modal-header__title`, children: title }),
      children
    ] }),
    backBtnClick && /* @__PURE__ */ jsx(
      Button,
      {
        prefix,
        type: "primary",
        inverseTheme: true,
        small: true,
        iconOnly: true,
        ssrIcon: arrowBack,
        onClick: backBtnClick,
        className: `${prefix}modal-header__back-button`,
        "aria-label": ariaBackBtnTxt
      }
    )
  ] });
};
var Header_default = ModalHeader;
export {
  ModalHeader,
  Header_default as default
};
